export default {
  country_locale: 'no-NO',
  wia_contact_links: {
    BK: 'https://www.bauknecht.no/Service/Kontakt-oss',
    ID: 'https://www.indesit.no/Indesit-Support/Kontaktskjema',
    WP: 'https://www.whirlpool.no/kundeservice/kontakt-oss'
  },
  wia_title: 'Internett ordre unngåelse',
  wia_need_help: 'Jeg trenger hjelp med',
  wia_model_name: 'Produkt navn er',
  wia_back: '< endre',
  wia_confirm: 'Bekreft',
  wia_issue_title: 'Hva er ditt problem?',
  wia_issue_concern: 'Mitt problem vedrører',
  wia_issue_specific: 'Angi ditt problem',
  wia_possible_solution: 'Mulige løsninger',
  wia_solved_issue: 'Har du løst problemet?',
  wia_closed: 'Lukk X',
  wia_feedback_ok: 'Ja!',
  wia_find_another_solution: 'Find en annen løsning',
  wia_feedback_title: 'Vi er glad for å høre at problemet ble løst!',
  wia_feedback_text1: 'Besøk vår internettbutikk med et spesielt tilbud dedikert til deg',
  wia_feedback_text2: 'Lær mer om vår nyeste smarte teknologi',
  wia_smile_up_popup_text1: 'Oppdag våre beskyttende planer',
  wia_smile_down_popup_title: 'Trenger mer hjelp?',
  wia_smile_down_popup_text1: 'Gå til neste step',
  wia_smile_down_popup_or_text: 'eller',
  wia_smile_down_popup_text2: 'Registrer en serviceordre',
  wia_need_more_help: 'Trenger mer hjelp?',
  wia_optional_label: '(valgfritt)',
  wia_no_solution: 'Dessverre finnes det ingen enkle selvbetjeningsløsninger for problemet ditt. Vennligst klikk her for støtte.',
  wia_all_solution: 'Alle løsninger',
  wia_all_categories: 'Alle kategorier',
  wia_seo_l1_issue: 'Alle feil pr. kategori',
  wia_seo_wp_country_name: 'NO',
  wia_seo_bk_country_name: 'NO',
  wia_seo_hp_country_name: 'NO',
  wia_seo_id_country_name: 'NO',
  wia_seo_wp_meta_title: 'Problem og løsninger',
  wia_seo_bk_meta_title: 'Problem og løsninger',
  wia_seo_hp_meta_title: 'Problem og løsninger',
  wia_seo_id_meta_title: 'Problem og løsninger',
  wia_seo_wp_meta_description: '',
  wia_seo_bk_meta_description: '',
  wia_seo_hp_meta_description: '',
  wia_seo_id_meta_description: '',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: '',
  wia_issue_search: '',
  wia_issue_description: '',
  wia_issue_placeholder: '',
  wia_issue_generic_macro_category: '',
  wia_issue_no_results: '',
  wia_issue_search_label: '',
  wia_related_solution: ''
}
